import React from 'react';
import { observer } from 'mobx-react';

import { Footer } from '../../../common/footer';
import { HomeNavbar } from '../../../common/home-navbar';
import { InformationMenu } from '../information-menu';
import { ScreenStore } from '../../../stores/ScreenStore';
import { constants } from '../../../config';
import { routeNaming, AppLink } from '../../../routes';
import styles from './PanavoxService.css';
import { SEO } from '../../../common/seo';

const serviceGoogleMapsLinks = {
  audioVideoPortablesService: 'https://goo.gl/maps/WsJprMBU23k',
  airConditionerService: 'https://goo.gl/maps/9PdWEgm5dwm',
  desktopPCsService: 'https://goo.gl/maps/UDCRDUkAKD22',
  homeService: 'https://goo.gl/maps/favWtW2LxM72',
};

const PanavoxService = observer(() => {
  const showMobileVersion = ScreenStore.screenWidth <= constants.breakpoints.mobileThreshold;
  return (
    <div className={styles.container}>
      <SEO
        title="Servicio PANAVOX"
        description="Accede a toda la información relevante sobre Carlos Gutiérrez S.A, nuestros servicios, políticas y cómo podemos ayudarte. Encuentra detalles sobre nuestros productos, condiciones de uso, privacidad, envíos y más. Estamos comprometidos a ofrecerte la mejor experiencia, brindándote transparencia y claridad en todos nuestros procesos. Si tienes preguntas o dudas, esta sección es tu recurso principal para obtener respuestas. Descubre todo lo que necesitas saber y disfruta de una experiencia de compra segura y satisfactoria con nosotros"
        type="website"
      />
      <HomeNavbar />
      <div className={styles.mainWrapper}>
        <div className={styles.mainContent}>
          {showMobileVersion ?
            <p className={styles.breadcrumb}>
              <AppLink
                className={styles.breadcrumb}
                routeName={routeNaming.INFORMATION_MENU_MOBILE}
              >
                Información
              </AppLink>
              <span> &gt; Servicios Oficiales {constants.panavoxLigature} </span>
            </p>
            : <InformationMenu indexSelectedItem={6} />}
          <div className={styles.bodyContainer}>
            <div className={styles.titleContainer}>
              <h1 className={styles.mainTitle}> Servicio {constants.panavoxLigature}</h1>
            </div>
            <div className={styles.contentSection}>
              <h2 className={styles.contentSectionTitle}>
                Audio, Video, Portables y Aspiradoras Robot e Inalámbricas
              </h2>
              <p>
                <b>Maipú 1933</b>, entre Rep. del Salvador y Santiago Gadea.
                &nbsp;
                <a
                  className={styles.mapLink}
                  href={serviceGoogleMapsLinks.audioVideoPortablesService}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  (Ver mapa)
                </a>
              </p>
              <p> Horario continuo de lunes a viernes de 8 a 18 hs. </p>
              <h3 className={styles.contentSectionSubtitle}> - Atención en nuestra planta: </h3>
              <p>
                Mini Componente, Micro
                Componente, TV LCD, TV LED, Home Theater, Soundbar,
                Reproductor, Notebooks y Grabador
                de DVD.
              </p>
              <h3 className={styles.contentSectionSubtitle}>
                - Servicio para TV CRT (de tubo) PANAVOX:
              </h3>
              <p>
                NEOTRON S.A.,&nbsp;
                <b>Dr. Aquiles R. Lanza 1208</b>, entre Soriano y Canelones.
              </p>
              <p> Tel.: 2902 1473. </p>
              <p> Horario continuo de lunes a viernes de 9 a 18 hs. </p>
              <p>
                Puede realizar el seguimiento de estos servicios en&nbsp;
                <AppLink
                  className={styles.webLink}
                  routeName={routeNaming.SERVICE_TRACKING}
                >
                  este link
                </AppLink>.
              </p>
              <br />
              <h2 className={styles.contentSectionTitle}> Aire Acondicionado </h2>
              <p>
                <b>Daniel Muñoz 2261</b>, entre Cufré y Acevedo Díaz.
                &nbsp;
                <a
                  className={styles.mapLink}
                  href={serviceGoogleMapsLinks.airConditionerService}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  (Ver mapa)
                </a>
              </p>
              <p> Tel.: 2409 4598 / 2408 0132 </p>
              <p>
                Horario continuo de lunes a viernes de 08:30 a 18 hs. y sábados de 8:30 a 13 hs.
              </p>
              <h3 className={styles.contentSectionSubtitle}>
                - Atención en nuestra planta y a domicilio:
              </h3>
              <p>
                Instalación, mantenimiento, y reparación de toda la línea de Aires
                Acondicionados PANAVOX.
              </p>
              <br />
              <h2 className={styles.contentSectionTitle}> Hogar & Línea Blanca </h2>
              <span style={{ fontWeight: 'bold' }}>Servicio oficial PANAVOX</span>
              <p>
                <b>Constitución 1981</b>, entre Miguelete y Nicaragua.
                &nbsp;
                <a
                  className={styles.mapLink}
                  href={serviceGoogleMapsLinks.homeService}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  (Ver mapa)
                </a>
              </p>
              <p> Tel.: 2400 0400* </p>
              <p> E-mail: info@rydesul.com </p>
              <p>
                Web:
                &nbsp;
                <a
                  className={styles.webLink}
                  href="http://www.rydesul.com"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  www.rydesul.com
                </a>
              </p>
              <p>
                Horario continuo de lunes a viernes de 9.00 a 18.00 hs y
                sábados de 9.00 a 13.00 hs.
              </p>
              <h3 className={styles.contentSectionSubtitle}> - Atención en nuestra planta: </h3>
              <p>
                Lavarropas, Secarropas, Lustra Aspiradoras, Máquinas de Coser,
                Bordeadoras, Estufas, Ventiladores
                y Aspiradoras convencionales (excluyendo modelo Robot e inalámbricos).
              </p>
              <h3 className={styles.contentSectionSubtitle}> - Atención a domicilio: </h3>
              <p>
                En la mayoría de las zonas de Montevideo. Por otras localidades consulte.
                Viáticos y gastos de traslado NO incluidos.
              </p>
              <p>
                Los productos que atendemos en su hogar son: Lavarropas, Lavavajillas, Microondas,
                Refrigeradores, Cocinas, Secarropas de tambor, Chimeneas y Purificadores.
              </p>
              <br />
              <h2 className={styles.contentSectionTitle}> PCs de escritorio </h2>
              <p>
                <b>UNICOM, Constitución 1618</b>, entre Uruguay y República.&nbsp;
                <a
                  className={styles.mapLink}
                  href={serviceGoogleMapsLinks.desktopPCsService}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  (Ver mapa)
                </a>
              </p>
              <p>
                Tel.: 2402 0000
              </p>
              <p>
                Horario: lunes a viernes de 9 a 13 hs. y de 14 a 18 hs.
              </p>
              <h3 className={styles.contentSectionSubtitle}> - Atención en nuestra planta: </h3>
              <p>
                Atención profesional y capacitada de toda la línea de PCs&nbsp;
                {constants.panavoxLigature}.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
});

export { PanavoxService };



// WEBPACK FOOTER //
// ./src/pages/information/panavox-service/PanavoxService.jsx